import { useMsal } from '@azure/msal-react'
import { mdiHistory } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter } from '@/components/ui/drawer'
import { Flex } from '@/components/ui/flex'
import { Stack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import { appEnvName } from '@/env/vars'
import useColorModeValue from '@/hooks/useColorModeValue'
import ConversationList from '@/pages/components/conversationList'
import Search from '@/pages/components/search'
import { mobileTranslateHistroyDrawerAtom, toggleTranslateHistoryMobileDrawer } from '@/store/mobile/MobileAtom'
import { showOneDriveButton } from '@/store/translate'

const MobileHistoryDrawer = () => {
    const { t } = useTranslation()
    const [isOpen] = useAtom(mobileTranslateHistroyDrawerAtom)
    const { accounts } = useMsal()
    const user = accounts[0]
    const onClose = () => {
        toggleTranslateHistoryMobileDrawer()
    }
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    const getOneDriveLink = () => {
        const username = user.username.replace(/\./g, '_').replace('@', '_')
        const env = appEnvName === 'local' ? '_DEV' : appEnvName === 'prod' ? '' : `_${appEnvName.toUpperCase()}`

        return `https://mydrive.gsk.com/personal/${username}/Documents/Documents/GiGi_Translations${env}`
    }
    return (
        <DrawerDialog isOpen={isOpen} onClose={onClose} size="md" noPadding={true}>
            <DrawerBody p="0" px="24px" mb="16px">
                <Box my="24px" height="calc(100% - 48px)">
                    <Flex alignItems="center">
                        <Icon
                            path={mdiHistory}
                            size="24px"
                            color="var(--chakra-colors-gray-800)"
                            style={{
                                marginRight: '18px',
                            }}
                        />
                        <Text
                            fontSize="21px"
                            fontFamily="GSKPrecision-Bold"
                            fontWeight="bold"
                            letterSpacing="0.25px"
                            display="flex"
                            lineHeight="20px"
                        >
                            {t('chat.settings.sections.history')}
                        </Text>
                    </Flex>
                    <Box pt="16px">
                        <Search />
                    </Box>
                    <Stack my="24px" height="calc(100% - 24px - 48px - 16px )" overflow="auto" justifyContent="space-between">
                        <ConversationList processingStrategy="Translation" />
                    </Stack>
                </Box>
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor={borderColor} display="block" mx="24px" px="0" py="24px">
                <Button variant="secondary" mr="18px" onClick={onClose} textTransform="uppercase" letterSpacing="0.25px">
                    {t('translate.mobile.drawer.buttons.close')}
                </Button>
                {showOneDriveButton() && (
                    <Button
                        variant="primary"
                        textTransform="uppercase"
                        letterSpacing="0.25px"
                        onClick={() => window.open(getOneDriveLink(), '_blank')}
                        px="64px"
                    >
                        {t('translate.mobile.drawer.buttons.oneDrive')}
                    </Button>
                )}
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default MobileHistoryDrawer
